const enum AlgorithmEnum {
  ALGORITHM_LIST = "/algorithm/QueryAssessmentAlgorithm",
}
export default AlgorithmEnum;
